export default function contactGroupReducer(contactGroup, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "addContact":
      return {
        ...contactGroup,
        units: [...contactGroup.units, { name: "", phone1: "", phone2: "", phone3: "" }],
      };

    default:
      return { ...contactGroup, [action.type]: action.value };
  }
}
